import { render, staticRenderFns } from "./Dashboardv2.vue?vue&type=template&id=893c2d6c&"
import script from "./Dashboardv2.vue?vue&type=script&lang=js&"
export * from "./Dashboardv2.vue?vue&type=script&lang=js&"
import style0 from "./Dashboardv2.vue?vue&type=style&index=0&id=893c2d6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports